<template>
  <div
    class="def-title"
    :class="{
      'def-title-1': result == 1,
      'def-title-2': result == 2,
      'def-title-3': result == 3,
      'def-title-center': center,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DefTitle',
  props: ['result', 'center'],
};
</script>

<style lang="scss" scoped>
.def-title {
  margin-bottom: 16px;
  :deep(> *) {
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 0;
  }
}
.def-title-1 {
  margin-bottom: 16px;
  :deep(> *) {
    font-size: 18px;
    font-weight: 600;
    line-height: 125%;
    @include point-md {
      font-size: 20px;
    }
    @include point-lg {
      font-size: 24px;
      margin-bottom: 24px;
    }
  }
}
.def-title-2 {
  :deep(> *) {
    font-size: rem(16);
    @include point-md {
      font-size: rem(18);
      line-height: 120%;
    }
  }
}
.def-title-3 {
  :deep(> *) {
    font-size: 16px;
    line-height: 125%;
    @include point-lg {
      font-size: 18px;
    }
  }
}
.def-title-center {
  text-align: center;
}
</style>
